import Color from 'color';

export const ipToSring = (ip, country) => {
  if (!ip) return '';
  let out = `${ip}`;
  if (country) {
    const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });
    regionNames.of('AR');
    out = `${out} (${regionNames.of(country)})`;
  }
  return out;
};

export const getFormUrl = (form) => `${import.meta.env.VITE_APP_URL_FORM}/f/${form.account}/${form.urlpath}/`;

export const getFormEmbedUrl = (form) => `${import.meta.env.VITE_APP_URL_FORM}/embed/${form.account}/${form.urlpath}.js`;

export const buildPalette = (color) => {
  const lightness = Color(color).hsl().color[2];
  const lightnessStep = (95 - lightness) / 5;
  const darknessStep = (lightness - 10) / 8;

  return {
    50: Color(color).lightness(lightness + lightnessStep * 5).saturate(0.32).hex(),
    100: Color(color).lightness(lightness + lightnessStep * 4).saturate(0.16).hex(),
    200: Color(color).lightness(lightness + lightnessStep * 3).saturate(0.08).hex(),
    300: Color(color).lightness(lightness + lightnessStep * 2).saturate(0.04).hex(),
    400: Color(color).lightness(lightness + lightnessStep * 1).hex(),
    500: Color(color).lightness(lightness).hex(),
    600: Color(color).lightness(lightness - darknessStep * 1).desaturate(0.4).hex(),
    700: Color(color).lightness(lightness - darknessStep * 3).desaturate(0.08).hex(),
    800: Color(color).lightness(lightness - darknessStep * 5).desaturate(0.16).hex(),
    900: Color(color).lightness(lightness - darknessStep * 7).desaturate(0.32).hex(),
  };
};
